<template>
  <div class="newIndex">
    <forwardType v-if="showModule === 'forwardType'"></forwardType>
    <newForword v-if="showModule === 'newForword'"></newForword>
    <newLayoutForword v-if="showModule === 'newLayoutForword'"></newLayoutForword>
  </div>
</template>

<script>
import forwardType from '@/views/forward_type/forwardType.vue'
import newForword from '@/views/forward_type/newForword.vue'
import newLayoutForword from '@/views/forward_type/new-layout-forword.vue'
export default {
  name:'newIndex',
  data() {
    return {
      showModule: 'forwardType'
    }
  },
  components: {
    forwardType,
    newForword,
    newLayoutForword
  },
  watch: {
    $route: {
      handler(to, from){
        if(to.path == '/forwardType') {
          this.showModule = 'forwardType'
        } else if(to.path == '/newForword') {
          this.showModule = 'newForword'
        } else if(to.path == '/newLayoutForword') {
          this.showModule = 'newLayoutForword'
        }
      },
      immediate: true,
    },
  }
}
</script>

<style>
.newIndex {
  width: 1500px;
  margin: 0 auto;
}

</style>
